// 参数域前端共享常量.
// v4 (2026-07-22): 框机/振镜/刺绣的硬编码 UI (FRAME_OPT/GALVO_OPT/STITCH_SCHEMA) 已随
// "设备差异下沉行级动态 schema" 的架构调整移除, 所有框架统一走 fields/params 渲染.

// 参数行状态枚举 (与后端 param 状态机对齐).
export const STATUS_OPTS: { v: string; label: string }[] = [
    { v: 'draft', label: '草稿' },
    { v: 'reviewing', label: '评审中' },
    { v: 'rejected', label: '已驳回' },
    { v: 'published', label: '已发布' },
];
